import getLabelFromStore from 'foundation/js/getLabelFromStore'
import { onMounted } from 'vue'

// Developer note: remove labels from props if it not needed in the component
export default {
    name: "StickyContactCard",
    props: {
        labels: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        // enabling store in component
        const getLabel = (labelKey, params) => getLabelFromStore({ labelKey, collectionName: 'StickyContactCard', params })
        
        const root = document.querySelector(".be-page-content__sticky-content-wrapper")

        const scrollToContactCardList = function () {
            // Scroll to card in contact card list
            root.querySelector(`#${props.labels.contactId}`).scrollIntoView({
                behavior: 'smooth'
            });
        }
        

        const animateOut = function (boolean) {
            // Animate sticky contact card in or out
            const stickyContactCard = root.querySelector(
                '.be-js--sticky-contact-card'
            )

            if (boolean === true) {
                // animate out
                stickyContactCard.classList.add(
                    'be-js--sticky-contact-card--hide'
                )
                stickyContactCard.classList.remove(
                    'be-js--sticky-contact-card--show'
                )

            } 
            
            if (boolean === false) {
                // animate in
                stickyContactCard.classList.remove(
                    'be-js--sticky-contact-card--hide'
                )
                stickyContactCard.classList.add(
                    'be-js--sticky-contact-card--show'
                )
            }
        }

        onMounted(() => {
            // the contact card list that should hide sticky contact card when visible
            const intersectionTarget = root.querySelector(`#${props.labels.contactId}`)
            
            const options = {
                // the container for sticky card
                rootMargin: "5px",
                threshold: 1,
            };

            const handleIntersection = (entries) => {

                entries.forEach((entry) => {
                    if (
                        entry.isIntersecting
                    ) {
                        animateOut(true)
                    } else if (
                        !entry.isIntersecting 
                    ) {
                        animateOut(false)
                    }

                })
            }

            const observer = new IntersectionObserver(handleIntersection, options);

            observer.observe(intersectionTarget);
        })


        return {
            getLabel,
            scrollToContactCardList
        }
    }
}